import { definePreset } from "@primeuix/themes";
import Material from "@primeuix/themes/material";

const Primary50 = "#d4f0ff";
const Primary100 = "#afd7ed";
const Primary200 = "#8db9d3";
const Primary300 = "#699bb9";
const Primary400 = "#4d86a5";
const Primary500 = "#2c7192";
const Primary600 = "#1e6381";
const Primary700 = "#0a4f6b";
const Primary800 = "#0a4f6b";
const Primary900 = "#003d56";

const Accent500 = "#afd7ed";
const Warn500 = "#e84118";

export const DiEnwPrime = definePreset(Material, {
  semantic: {
    primary: {
      50: Primary50,
      100: Primary100,
      200: Primary200,
      300: Primary300,
      400: Primary400,
      500: Primary500,
      600: Primary600,
      700: Primary700,
      800: Primary800,
      900: Primary900,
    },

    colorScheme: {
      light: {
        primary: {
          color: "{primary.500}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.600}",
          activeColor: "{primary.700}",
          borderColor: "{primary.500}",
        },
        highlight: {
          background: Accent500,
        },
        danger: {
          color: Warn500,
        },
      },
    },
  },

  components: {
    checkbox: {
      root: {
        checkedBackground: "{primary.color}",
        checkedBorderColor: "{primary.color}",
        checkedHoverBackground: "{primary.hover.color}",
        checkedHoverBorderColor: "{primary.hover.color}",
        checkedFocusBorderColor: "{primary.color}",
      },
      icon: {
        color: "#ffffff",
      },
    },
    multiselect: {
      root: {
        focusRing: {
          color: "{primary.color}",
        },
      },
    },
  },
});
